(() => {
  document.addEventListener(
    'click',
    /** @param {MouseEvent} e */
    (e) => {
      const target = /** @type {HTMLElement | null} */ (e.target);
      const expandBtn = target?.closest?.('[data-text-read-more-expand]');
      const collapseBtn = target?.closest?.('[data-text-read-more-collapse]');
      if (!expandBtn && !collapseBtn) return;

      const root =
        (expandBtn || collapseBtn)?.closest?.('[data-text-read-more]');
      if (!root) return;

      e.preventDefault();

      const preview = root.querySelector('[data-text-read-more-preview]');
      const expanded = root.querySelector('[data-text-read-more-expanded]');

      if (expandBtn && preview && expanded) {
        preview.hidden = true;
        expanded.hidden = false;
        expandBtn.setAttribute('aria-expanded', 'true');
        return;
      }

      if (collapseBtn && preview && expanded) {
        expanded.hidden = true;
        preview.hidden = false;
        const openBtn = root.querySelector('[data-text-read-more-expand]');
        openBtn?.setAttribute('aria-expanded', 'false');
      }
    },
    false
  );
})();
